
//Jquery is loaded from WordPress, externalized in webpack build, this line is ok.
try { // Import webpack jQ
  window.$ = window.jQuery = require('jquery')
} catch (e) {}



$(function(){
  // Hack to get the REAL window size
  $('body, html').css('overflow', 'hidden').css('overflow', 'visible')
})

$(document).ready(() => {

    //Do not remove the comment webpackChunkName as it sets the name of split chunk
    import(
        /* webpackChunkName: "datalayerevents" */
        './dataLayerEvents'
        ).then(({ addDataLayerEvent  }) => {
        console.log('data layer events loaded')
        addDataLayerEvent();
    });

  // Libs
  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "jquery-touchswipe" */
      './jquery.touchSwipe.min.js'
      );
  import(
      /* webpackChunkName: "masonry" */
      './masonry.pkgd.min.js'
      );
  import(
      /* webpackChunkName: "select2" */
      './select2.min.js'
      );
  import(
      /* webpackChunkName: "jquerydatepicker" */
      './jquerydatepicker1141.min.js'
      );

  import(/* webpackChunkName: "hyphenation" */
      './hyphenation'
      );

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "header" */
      './header'
      ).then(() => {
    console.log('loaded header js')
  })

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "filters" */
      './filters'
      );

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "expands" */
      './expands'
      );

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "archivefilterexpands" */
      './archiveFilterExpands'
      );

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "linkedinsharefix" */
      './linkedinShareFix'
      );

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "facebooksharefix" */
      './facebookShareFix'
      );

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "twittersharefix" */
      './twitterShareFix'
      );

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "defaultblocksfix" */
      './defaultBlocksfix'
      );

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "archiveshortcode" */
      './archiveShortCode'
      );

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "commonthemejs" */
      './commonThemeJs'
      );

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "location" */
      './location'
      );

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "headersearch" */
      './headerSearch'
      )

  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "themeaccessibility" */
      './themeAccessibility'
      );


  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "embedplaceholdermodifier" */
      "./embedPlaceholderModifier"
      ).then(({embedPlaceholderModifier}) => {
          embedPlaceholderModifier()
      });


  //Do not remove the comment webpackChunkName as it sets the name of split chunk
  import(
      /* webpackChunkName: "gtm-analytics" */
      './gtm-analytics'
      ).then(({gtmAnalytics}) => {
        gtmAnalytics();
      });

})


console.log('Test new safe');
